(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rf-carousel')) {
    class RfCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.rf-slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.toggle = this.querySelector('[data-toggle]');
        if (this.slides.length < 2) return;
        this.index = 0;
        this.delay = parseInt(this.dataset.delay, 10) || 7000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.reduced;
        this.hoverPaused = false;

        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10))));
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        });
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.sync(); });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.sync(); });
        this.addEventListener('focusin', () => { this.hoverPaused = true; this.sync(); });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) { this.hoverPaused = false; this.sync(); }
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { this.go(this.index - 1); }
        });
        document.addEventListener('visibilitychange', () => this.sync());
        this.go(0, false);
        this.sync();
      }

      disconnectedCallback() { clearInterval(this.timer); }

      go(i, announce = true) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.slides.forEach((slide, n) => {
          const on = n === this.index;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('inert', !on);
          if (on) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
        });
        this.dots.forEach((dot, n) => {
          if (n === this.index) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
        });
        const track = this.querySelector('.rf-carousel__track');
        track.setAttribute('aria-live', announce && this.userPaused ? 'polite' : 'off');
        this.restart();
      }

      restart() {
        clearInterval(this.timer);
        if (this.userPaused || this.hoverPaused || document.hidden) return;
        this.timer = setInterval(() => this.go(this.index + 1, false), this.delay);
      }

      sync() {
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.setAttribute('aria-label', this.userPaused ? 'Play the carousel' : 'Pause the carousel');
        this.restart();
      }
    }
    customElements.define('rf-carousel', RfCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
